import { useApp } from '../App';
import BackButton from '../components/BackButton';
import { useState, useEffect } from 'react';
import api from '../api';
import Loading from '../components/Loading';
import CompanyGate from '../components/CompanyGate';
import { useI18n } from '../i18n/index.jsx';

function KartaPobytuInner() {
  const { user, setPage } = useApp();
  const { t } = useI18n();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(0); // 0=list, 1=form, 2=docs, 3=done
  const [currentId, setCurrentId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [form, setForm] = useState({
    company_id: '', purpose: 'praca', arrival_date: '', employer_name: '',
    job_position: '', monthly_salary: '', accommodation: '',
  });
  const [msg, setMsg] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const [c, comp] = await Promise.all([api.get('/karta-pobytu'), api.get('/companies')]);
      setCases(c.data);
      setCompanies(comp.data);
      if (comp.data.length && !form.company_id) setForm(f => ({ ...f, company_id: comp.data[0].id }));
    } catch {}
    setLoading(false);
  }

  async function createCase() {
    setMsg('');
    try {
      const { data } = await api.post('/karta-pobytu', {
        company_id: Number(form.company_id),
        app_type: 'karta_pobytu',
        form_data: JSON.stringify(form),
        notes: `Cel pobytu: ${form.purpose}`,
      });
      setCurrentId(data.id);
      setStep(2);
      setMsg('✅ Анкета создана. Загрузите документы.');
    } catch (e) { setMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function uploadDoc(docType, file) {
    if (!file || !currentId) return;
    const fd = new FormData();
    fd.append('file', file);
    try {
      await api.post(`/karta-pobytu/${currentId}/files?doc_type=${docType}`, fd,
        { headers: { 'Content-Type': 'multipart/form-data' } });
      setMsg(`✅ ${docType} загружен`);
    } catch (e) { setMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function generatePackage() {
    try {
      await api.post(`/karta-pobytu/${currentId}/generate-package`);
      setMsg('✅ Пакет сформирован!');
      setStep(0);
      load();
    } catch (e) { setMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function downloadPkg(id) {
    window.open(`https://api.workifypl.com/karta-pobytu/${id}/package`, '_blank');
  }

  if (loading) return <Loading />;

  // Step 1: Questionnaire
  if (step === 1) return (
    <div className="page">
      <BackButton />
      <h1>🛂 Karta Pobytu — Анкета</h1>
      <div className="form">
        <div className="field"><label>Фирма</label>
          <select value={form.company_id} onChange={e => setForm({ ...form, company_id: e.target.value })}>
            {companies.map(c => <option key={c.id} value={c.id}>{c.short_name || c.name}</option>)}
          </select></div>
        <div className="field"><label>Цель пребывания</label>
          <select value={form.purpose} onChange={e => setForm({ ...form, purpose: e.target.value })}>
            <option value="praca">Praca (Работа)</option>
            <option value="studia">Studia (Учёба)</option>
            <option value="rodzina">Łączenie z rodziną</option>
          </select></div>
        <div className="field"><label>Дата приезда в Польшу</label>
          <input type="date" value={form.arrival_date} onChange={e => setForm({ ...form, arrival_date: e.target.value })} /></div>
        <div className="field"><label>Работодатель</label>
          <input value={form.employer_name} onChange={e => setForm({ ...form, employer_name: e.target.value })} /></div>
        <div className="field"><label>Должность</label>
          <input value={form.job_position} onChange={e => setForm({ ...form, job_position: e.target.value })} /></div>
        <div className="field"><label>Зарплата (PLN/мес)</label>
          <input type="number" value={form.monthly_salary} onChange={e => setForm({ ...form, monthly_salary: e.target.value })} /></div>
        <div className="field"><label>Жильё</label>
          <input value={form.accommodation} onChange={e => setForm({ ...form, accommodation: e.target.value })} placeholder="Адрес проживания" /></div>
      </div>
      {msg && <div className="message">{msg}</div>}
      <div className="actions">
        <button className="btn btn-primary" onClick={createCase}>Далее →</button>
        <button className="btn btn-secondary" onClick={() => setStep(0)}>{t('common.cancel')}</button>
      </div>
    </div>
  );

  // Step 2: Upload documents
  if (step === 2) return (
    <div className="page">
      <BackButton />
      <h1>🛂 Загрузка документов</h1>
      <p>Загрузите необходимые документы:</p>
      <div className="form">
        {['passport', 'photo_3x4', 'contract', 'accommodation', 'insurance', 'other'].map(dt => (
          <div key={dt} className="field">
            <label>{{passport:'Паспорт',photo_3x4:'Фото 3x4',contract:'Договор',accommodation:'Мельдунек',insurance:'Страховка',other:'Другое'}[dt]}</label>
            <input type="file" onChange={e => uploadDoc(dt, e.target.files[0])} />
          </div>
        ))}
      </div>
      {msg && <div className="message">{msg}</div>}
      <div className="actions">
        <button className="btn btn-primary" onClick={generatePackage}>📦 Сформировать пакет</button>
        <button className="btn btn-secondary" onClick={() => { setStep(0); load(); }}>Позже</button>
      </div>
    </div>
  );

  // List
  return (
    <div className="page">
      <BackButton />
      <h1>🛂 Karta Pobytu</h1>
      <button className="btn btn-primary" onClick={() => setStep(1)}>+ Новая заявка</button>
      {cases.length === 0 ? <div className="empty">{t('karta_pobytu.no_cases')}</div> :
        <div className="list">
          {cases.map(c => (
            <div key={c.id} className="list-item">
              <div className="list-main">
                <div className="list-title">Karta Pobytu #{c.id}</div>
                <div className="list-sub">{c.created_at?.split('T')[0]} • {c.documents?.length || 0} документов</div>
              </div>
              <div className="list-right">
                <div className={`status-badge status-${c.status}`}>{c.status}</div>
                {c.package_path && <button className="btn btn-small" onClick={() => downloadPkg(c.id)}>📥</button>}
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

export default function KartaPobytu() {
  return <CompanyGate allowWithout><KartaPobytuInner /></CompanyGate>;
}
